import { Flex, Link, Text } from '@servicetitan/anvil2';
import { formatPhoneNumber } from '@servicetitan/financing-utils-shared';
import { ApplicationDataStore } from '../application/ApplicationDataStore';

export const TurnsDisclosureText = () => {
    const { applicationData } = ApplicationDataStore.useStore();
    const rawPhone =
        applicationData.applicant.primaryApplicant?.primaryPhone ??
        applicationData.externalApplication.primaryPhone;
    const phoneNumber = rawPhone ? formatPhoneNumber(rawPhone) : '(XXX) XXX-XXXX';

    return (
        <Flex direction="column" gap="4">
            <Text variant="body">
                By checking the box and clicking "Continue" you acknowledge, agree, and consent to
                the following:
            </Text>
            <Text variant="body">
                1. I read and agree to the{' '}
                <Link
                    href="https://turns.s3.us-east-1.amazonaws.com/Turns+Privacy+Policy+062124.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Privacy Policy
                </Link>
                ,{' '}
                <Link
                    href="https://turns.s3.us-east-1.amazonaws.com/Turns+Public+Terms+and+Conditions+082124.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Terms & Conditions
                </Link>
                ,{' '}
                <Link
                    href="https://turns.s3.us-east-1.amazonaws.com/Turns+E-Consent+062124.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Consent for Electronic Signatures, Records, and Disclosures
                </Link>
                .
            </Text>
            <Text variant="body">
                2. I authorize Platform Operator, under the Fair Credit Reporting Act, to obtain
                information from my personal credit report and other information from one or more
                consumer reporting agencies to prequalify me for a loan. I also authorize Platform
                Operator to share my information with financing, leasing, and marketing partners,
                and for these parties to use my information to obtain credit report information from
                any reporting agency.
            </Text>
            <Text variant="body">
                3. I give express written consent to receive recurring communications from Platform
                Operator,{' '}
                <Link
                    href="https://servicetitanturns.s3.us-east-1.amazonaws.com/Turns+Financing+Partner+Link+for+ST+Consents.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    its financing, leasing, and marketing partners
                </Link>
                , including live, autodialed, and prerecorded text messages (SMS), emails, and calls
                regarding my request and related services at {phoneNumber}, even if my number is on
                the state/federal Do-Not-Call list. I understand that my consent to receive
                communications is not required to use this service, and message/data rates may
                apply.
            </Text>
            <Text variant="body">
                4. I understand Platform Operator is NOT a partner or lessor, does not make offers
                for financing or leasing applications, and does not make credit decisions.
            </Text>
        </Flex>
    );
};
